// Keys held in memory while the app is unlocked. Nothing here is ever written anywhere in
// plain form; locking the app drops all of it.

export class AppLockedError extends Error {
  constructor() {
    super('The app is locked');
  }
}

export class VaultLockedError extends Error {
  constructor(public vaultId: string) {
    super('This vault is locked');
  }
}

let dataKey: CryptoKey | null = null;
let privateKey: CryptoKey | null = null;
const vaultKeys = new Map<string, CryptoKey>();

export const keys = {
  get unlocked(): boolean {
    return dataKey !== null;
  },
  setDataKey(key: CryptoKey | null) {
    dataKey = key;
  },
  setPrivateKey(key: CryptoKey | null) {
    privateKey = key;
  },
  dataKey(): CryptoKey {
    if (!dataKey) throw new AppLockedError();
    return dataKey;
  },
  privateKey(): CryptoKey {
    if (!privateKey) throw new AppLockedError();
    return privateKey;
  },
  /** The key that opens a record: its vault's key, else the account data key. */
  forVault(vaultId: string | null | undefined): CryptoKey {
    if (!vaultId) return keys.dataKey();
    const k = vaultKeys.get(vaultId);
    if (!k) throw new VaultLockedError(vaultId);
    return k;
  },
  hasVault(vaultId: string): boolean {
    return vaultKeys.has(vaultId);
  },
  setVault(vaultId: string, key: CryptoKey) {
    vaultKeys.set(vaultId, key);
  },
  dropVault(vaultId: string) {
    vaultKeys.delete(vaultId);
  },
  openVaults(): string[] {
    return [...vaultKeys.keys()];
  },
  clear() {
    dataKey = null;
    privateKey = null;
    vaultKeys.clear();
  },
};
